import { useEffect } from 'react';
import { trackCheckoutPaymentModalView } from './pulseCheckoutPaymentViews';

/** Pulse view for split-payment add/replace credit or gift card sub-modals. */
export function useCheckoutSplitPaymentModalPulseView(params: {
  addPaymentCard: boolean;
  addGiftCard: boolean;
  replacePaymentCards: boolean;
  replaceGiftCards: boolean;
  pagePath?: string;
}): void {
  const {
    addPaymentCard,
    addGiftCard,
    replacePaymentCards,
    replaceGiftCards,
    pagePath,
  } = params;

  useEffect(() => {
    if (!addPaymentCard) return;
    trackCheckoutPaymentModalView({
      kind: 'credit',
      isEdit: false,
      pagePath,
    });
  }, [addPaymentCard, pagePath]);

  useEffect(() => {
    if (!addGiftCard) return;
    trackCheckoutPaymentModalView({
      kind: 'gift',
      isEdit: false,
      pagePath,
    });
  }, [addGiftCard, pagePath]);

  useEffect(() => {
    if (!replacePaymentCards) return;
    trackCheckoutPaymentModalView({
      kind: 'credit',
      isEdit: true,
      pagePath,
    });
  }, [replacePaymentCards, pagePath]);

  useEffect(() => {
    if (!replaceGiftCards) return;
    trackCheckoutPaymentModalView({
      kind: 'gift',
      isEdit: true,
      pagePath,
    });
  }, [replaceGiftCards, pagePath]);
}
